import * as React from 'react';
import Container from '@mui/material/Container';

export default function MarloweMap() {
  return (
    <Container sx={{
      height: "auto",
      aspectRatio: "16 / 9",
      maxHeight: "450px",
    }}>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6202.685456557141!2d-71.0775123221489!3d42.367867071192414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e37769ce860ff5%3A0x7da9ccf3ac860cd0!2sKimpton%20Marlowe%20Hotel!5e1!3m2!1sen!2sus!4v1735019763493!5m2!1sen!2sus"
        width="100%" 
        height="100%"
        allowfullScreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade" />
    </Container>
  );
}
